import { getHostFromEnv } from "../environments.js";

// Re-export for convenience
export { getHostFromEnv };

// Get current environment
const environment = getHostFromEnv("ENV");

console.log("Environment is: ", environment);

export const ILEGGELSE_SERVICE_BASE_URL =
  getHostFromEnv("URL_SERVICE") + "/api";
export const INNTAUING_WEB_BASE_URL = getHostFromEnv("URL_INNTAUING_WEB");
